exports.urlSchema = {
  about: { en: '/about/', de: '/ueber/' },
  imprint: { en: '/imprint/', de: '/impressum/' },
  forPreppers: { en: '/for-preppers/', de: '/krisenvorsorge/' },
  // forSharedApartments: { en: '/for-shared-apartments/', de: '/fuer-wohngemeinschaften/' },
  // forFamilies: { en: '/for-families/', de: '/fuer-familien/' },
  // forEcologicallyAware: { en: '/for-ecologically-aware/', de: '/fuer-naturbewusste/' },
  // forHobbyChefs: { en: '/for-hobby-chefs/', de: '/fuer-hobbykoeche/' },
  pricing: { en: '/pricing/', de: '/preise/' },
  privacyStatement: { en: '/privacy-statement/', de: '/datenschutz-erklaerung/' },
}
